import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface UpdateNoteParams {
  noteId: string;
  note: string;
}

interface UpdateNoteResponse {
  message: string;
}

export const updateNoteAPI = async ({ noteId, note }: UpdateNoteParams) => {
  const response = await baseAPI.patch<UpdateNoteResponse>(`/notes/${noteId}`, {
    note,
  });
  return response.data;
};

export const useUpdateNote = () => {
  return useMutation({
    mutationFn: (params: UpdateNoteParams) => updateNoteAPI(params),

    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.NOTES],
      });
    },
  });
};
